import { VALID } from './general';

const auPostalCodeRegex =
  /^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/;

export const auPostalCode = (errorMsg: string) => (value: string) => {
  if (!value) return VALID;
  return auPostalCodeRegex.test(value) ? VALID : errorMsg;
};
